import React from "react";
import { Row, Col } from "reactstrap";
import withStyles from "isomorphic-style-loader/withStyles";
import FormCheckbox from "../../../../../../../toolkit/formCheckbox";
import s from "../styles.scss";

interface AssetSectionProps {
  title: string;
  fieldName: string;
  preview: string;
  customPreview?: React.ReactNode;
  variant?: "row" | "two-rows";
  previewClassName?: string;
}

const AssetSection: React.FC<AssetSectionProps> = ({
  title,
  fieldName,
  preview,
  customPreview,
  variant = "two-rows",
  previewClassName,
}) => {

  const renderContent = () => {
    if (variant === "row") {
      return (
        <Row className="align-items-center">
          <Col xs="auto">
            <FormCheckbox name={fieldName} />
          </Col>
          <Col xs="auto">
            <h6 className={s.sectionTitle}>{title}</h6>
          </Col>
          <Col className="d-flex justify-content-end">
            <div className={s.preview}>
              {customPreview || (
                <p className={previewClassName ? `${s.previewText} ${previewClassName}` : s.previewText}>
                  {preview}
                </p>
              )}
            </div>
          </Col>
        </Row>
      );
    }

    return (
      <>
        <Row className="align-items-center mb-2">
          <Col xs="auto">
            <FormCheckbox name={fieldName} />
          </Col>
          <Col>
            <h6 className={s.sectionTitle}>{title}</h6>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className={s.preview}>
              {customPreview || (
                <p className={previewClassName ? `${s.previewText} ${previewClassName}` : s.previewText}>
                  {preview}
                </p>
              )}
            </div>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <div className={s.sectionItem}>
      {renderContent()}
    </div>
  );
};

export default withStyles(s)(AssetSection);
